import { render, staticRenderFns } from "./ForgetMe.vue?vue&type=template&id=2a8f0c1a&"
import script from "./ForgetMe.vue?vue&type=script&lang=js&"
export * from "./ForgetMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports